import React, {Component} from 'react';
import RouteDetailContextProvider from "./context/RouteDetailContext";
import CapabilityContextProvider from "../global/context/CapabilityContext";
import RouteDetailView from "./RouteDetailView";
import PickContextProvider from "../pickStatus/context/PickContext";
import DWPFileContextProvider from "../fileupload/context/DWPUploadContext";
import AssociateContextProvider from "../associate/context/AssociateContextProvider";
import AlertContextProvider from "../alert/context/AlertContext";

class RouteDetailComponent extends Component {
    render() {
        return (
            <CapabilityContextProvider>
                <AlertContextProvider>
                    <RouteDetailContextProvider params = {this.props.match.params}>
                        <PickContextProvider>
                            <DWPFileContextProvider>
                                <AssociateContextProvider>
                                    <RouteDetailView history={this.props.history} route={this.props.match.params}/>
                                </AssociateContextProvider>
                            </DWPFileContextProvider>
                        </PickContextProvider>
                    </RouteDetailContextProvider>
                </AlertContextProvider>
            </CapabilityContextProvider>
    )
    }
}

export default RouteDetailComponent


// WEBPACK FOOTER //
// ./src/components/routeDrillDown/RouteDetailComponent.js